export default "__VITE_ASSET__Ba1n_gBu__"